<template>
    <SvgIcon :symbol-data="symbolData()"/>
</template>

<script lang="ts">
import SvgIcon from '@/icons/SvgIcon.vue';
import {defineComponent, PropType} from 'vue';
import icons, {SvgSymbolData} from '../icons';

export default defineComponent({
    components: {SvgIcon},
    props: {
        dataIcon: {
            type: String as PropType<keyof typeof icons>,
            required: true,
        },
    },
    setup(props) {
        function symbolData(): SvgSymbolData {
            return icons[props.dataIcon] as SvgSymbolData;
        }

        return {symbolData};
    },
});
</script>
